/**
 * Product image swipe + pinch zoom (with floating overlay buttons)
 */
(function () {
  'use strict';

  /* ── Helpers ────────────────────────────────────────────────────────────── */
  function getVisibleSrcs() {
    var srcs = [];
    if (window.carouselState && carouselState.visibleThumbnails && carouselState.visibleThumbnails.length) {
      carouselState.visibleThumbnails.forEach(function (item) {
        var img = item.element.querySelector('img');
        if (img && img.dataset.fullImage) srcs.push(img.dataset.fullImage);
      });
    } else {
      document.querySelectorAll('.product-info-carousel__thumbnail img').forEach(function (img) {
        if (img.dataset.fullImage) srcs.push(img.dataset.fullImage);
      });
    }
    return srcs;
  }

  function getCurrentVisibleIndex() {
    var active = document.querySelector('.product-info-carousel__thumbnail.active');
    if (!active) return 0;
    var globalIdx = parseInt(active.dataset.imageIndex) || 0;
    if (window.carouselState && carouselState.visibleThumbnails) {
      for (var i = 0; i < carouselState.visibleThumbnails.length; i++) {
        if (parseInt(carouselState.visibleThumbnails[i].element.dataset.imageIndex) === globalIdx) return i;
      }
    }
    return globalIdx;
  }

  function goToVisibleIndex(visIdx) {
    var list = (window.carouselState && carouselState.visibleThumbnails && carouselState.visibleThumbnails.length)
      ? carouselState.visibleThumbnails
      : Array.from(document.querySelectorAll('.product-info-carousel__thumbnail')).map(function (el) { return { element: el }; });
    if (visIdx < 0 || visIdx >= list.length) return;
    var thumb = list[visIdx].element;
    var globalIdx = parseInt(thumb.dataset.imageIndex);
    if (!isNaN(globalIdx) && window.selectThumbnail) {
      selectThumbnail(globalIdx);
    } else {
      var img = thumb.querySelector('img');
      var mainImg = document.getElementById('product-main-image');
      if (img && mainImg) { mainImg.src = img.dataset.fullImage || img.src; mainImg.alt = img.alt || ''; }
      document.querySelectorAll('.product-info-carousel__thumbnail').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    }
  }

  /* ── Swipe on main image (no dots, no DOM changes) ─────────────────────── */
  var SWIPE_MIN = 40;
  var swipeX = 0, swipeY = 0;

  var mainWrap = document.querySelector('.product-info-carousel__main-image');
  if (mainWrap) {
    mainWrap.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      swipeX = e.touches[0].clientX;
      swipeY = e.touches[0].clientY;
    }, { passive: true });

    mainWrap.addEventListener('touchend', function (e) {
      if (e.changedTouches.length !== 1) return;
      var dx = e.changedTouches[0].clientX - swipeX;
      var dy = e.changedTouches[0].clientY - swipeY;
      if (Math.abs(dx) < SWIPE_MIN || Math.abs(dy) > Math.abs(dx)) return;
      var srcs = getVisibleSrcs();
      var cur = getCurrentVisibleIndex();
      goToVisibleIndex(dx < 0 ? Math.min(cur + 1, srcs.length - 1) : Math.max(cur - 1, 0));
    }, { passive: true });
  }

  /* ── Zoom overlay with Integrated UI Navigation Buttons ────────────────── */
  var overlay  = document.getElementById('pic-zoom-overlay');
  var zoomImg  = document.getElementById('pic-zoom-img');
  var closeBtn = document.getElementById('pic-zoom-close');
  
  // Custom Floating Control References
  var prevBtn  = document.getElementById('pic-zoom-prev');
  var nextBtn  = document.getElementById('pic-zoom-next');

  var zScale = 1, zMaxScale = 5;
  var zTx = 0, zTy = 0;
  var zLastDist = 0, zPinching = false;
  var zDragging = false, zDragX = 0, zDragY = 0;

  function applyZ() {
    zoomImg.style.transform = 'translate(' + zTx + 'px,' + zTy + 'px) scale(' + zScale + ')';
    updateNavButtonsState();
  }

  function clamp() {
    var ow = overlay.offsetWidth, oh = overlay.offsetHeight;
    var iw = (zoomImg.naturalWidth  || ow) * zScale;
    var ih = (zoomImg.naturalHeight || oh) * zScale;
    var mx = Math.max(0, (iw - ow) / 2);
    var my = Math.max(0, (ih - oh) / 2);
    zTx = Math.max(-mx, Math.min(mx, zTx));
    zTy = Math.max(-my, Math.min(my, zTy));
  }

  function updateNavButtonsState() {
    var srcs = getVisibleSrcs();
    var cur = getCurrentVisibleIndex();
    
    // Hide or disable navigation layout if zoomed in or if only 1 image exists
    var isDisabledOrZoomed = zScale > 1.05 || srcs.length <= 1;

    if (prevBtn) prevBtn.disabled = isDisabledOrZoomed || cur === 0;
    if (nextBtn) nextBtn.disabled = isDisabledOrZoomed || cur === srcs.length - 1;
  }

  function navigateModal(direction) {
    if (zScale > 1.05) return; // Block switches when looking closely at zoom elements
    var srcs = getVisibleSrcs();
    var cur = getCurrentVisibleIndex();
    var targetIdx = cur + direction;

    if (targetIdx >= 0 && targetIdx < srcs.length) {
      goToVisibleIndex(targetIdx);
      var newSrc = srcs[targetIdx];
      if (newSrc) {
        zScale = 1; zTx = 0; zTy = 0;
        zoomImg.src = newSrc;
        applyZ();
      }
    }
  }

  function openZoom(src, alt) {
    zScale = 1; zTx = 0; zTy = 0;
    zoomImg.src = src;
    zoomImg.alt = alt || '';
    applyZ();
    overlay.classList.add('is-open');
    document.body.classList.add('bb-scroll-lock');
  }

  function closeZoom() {
    overlay.classList.remove('is-open');
    document.body.classList.remove('bb-scroll-lock');
    setTimeout(function () { zoomImg.src = ''; }, 300);
  }

  if (closeBtn) closeBtn.addEventListener('click', closeZoom);
  if (overlay) {
    overlay.addEventListener('click', function (e) {
      // Do not close the modal window if clicking navigation elements
      if (e.target === overlay || e.target === zoomImg) {
        closeZoom();
      }
    });
  }

  // Floating Navigation Click Hooks
  if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); navigateModal(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); navigateModal(1); });

  document.addEventListener('keydown', function (e) {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeZoom();
    if (e.key === 'ArrowLeft') navigateModal(-1);
    if (e.key === 'ArrowRight') navigateModal(1);
  });

  // Click main image → open zoom
  document.addEventListener('click', function (e) {
    var t = e.target.closest('#product-main-image');
    if (t) openZoom(t.src, t.alt);
  });

  if (overlay) {
    /* Pinch zoom */
    overlay.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        zPinching = true; zDragging = false;
        var dx = e.touches[0].clientX - e.touches[1].clientX;
        var dy = e.touches[0].clientY - e.touches[1].clientY;
        zLastDist = Math.sqrt(dx*dx + dy*dy);
        e.preventDefault();
      } else if (e.touches.length === 1 && zScale > 1) {
        // Prevent pan listeners from blocking explicit buttons clicks
        if (e.target.closest('.pic-zoom-nav-btn') || e.target.id === 'pic-zoom-close') return;
        zDragging = true; zPinching = false;
        zDragX = e.touches[0].clientX - zTx;
        zDragY = e.touches[0].clientY - zTy;
      }
    }, { passive: false });

    overlay.addEventListener('touchmove', function (e) {
      if (zPinching && e.touches.length === 2) {
        var dx = e.touches[0].clientX - e.touches[1].clientX;
        var dy = e.touches[0].clientY - e.touches[1].clientY;
        var d = Math.sqrt(dx*dx + dy*dy);
        zScale = Math.max(1, Math.min(zMaxScale, zScale * (d / zLastDist)));
        zLastDist = d;
        clamp(); applyZ();
        e.preventDefault();
      } else if (zDragging && e.touches.length === 1 && zScale > 1) {
        zTx = e.touches[0].clientX - zDragX;
        zTy = e.touches[0].clientY - zDragY;
        clamp(); applyZ();
        e.preventDefault();
      }
    }, { passive: false });

    overlay.addEventListener('touchend', function (e) {
      if (e.touches.length < 2) zPinching = false;
      if (e.touches.length === 0) { zDragging = false; if (zScale < 1) { zScale = 1; zTx = 0; zTy = 0; applyZ(); } }
    }, { passive: true });

    /* Double-tap toggle */
    var lastTap = 0;
    overlay.addEventListener('touchend', function (e) {
      if (e.target.closest('.pic-zoom-nav-btn') || e.target.id === 'pic-zoom-close') return;
      var now = Date.now();
      if (now - lastTap < 280 && e.changedTouches.length === 1) {
        zScale = zScale > 1 ? 1 : 2.5; zTx = 0; zTy = 0; applyZ();
      }
      lastTap = now;
    }, { passive: true });

    /* Mouse wheel zoom */
    overlay.addEventListener('wheel', function (e) {
      e.preventDefault();
      zScale = Math.max(1, Math.min(zMaxScale, zScale * (e.deltaY > 0 ? 0.85 : 1.15)));
      clamp(); applyZ();
    }, { passive: false });

    /* Mouse drag when zoomed */
    overlay.addEventListener('mousedown', function (e) {
      if (zScale <= 1 || e.target === closeBtn || e.target.closest('.pic-zoom-nav-btn')) return;
      zDragging = true; zDragX = e.clientX - zTx; zDragY = e.clientY - zTy;
      overlay.style.cursor = 'grabbing';
    });
    window.addEventListener('mousemove', function (e) {
      if (!zDragging) return;
      zTx = e.clientX - zDragX; zTy = e.clientY - zDragY;
      clamp(); applyZ();
    });
    window.addEventListener('mouseup', function () {
      if (!zDragging) return;
      zDragging = false;
      overlay.style.cursor = zScale > 1 ? 'grab' : 'zoom-out';
    });

    /* Swipe inside overlay to navigate (only when not zoomed) */
    var ozX = 0, ozY = 0;
    overlay.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1 && zScale <= 1.05) { ozX = e.touches[0].clientX; ozY = e.touches[0].clientY; }
    }, { passive: true });
    overlay.addEventListener('touchend', function (e) {
      if (e.target.closest('.pic-zoom-nav-btn') || e.target.id === 'pic-zoom-close') return;
      if (e.changedTouches.length !== 1 || zScale > 1.05) return;
      var dx = e.changedTouches[0].clientX - ozX;
      var dy = e.changedTouches[0].clientY - ozY;
      if (Math.abs(dx) < SWIPE_MIN || Math.abs(dy) > Math.abs(dx)) return;
      navigateModal(dx < 0 ? 1 : -1);
    }, { passive: true });
  }
})();